// extracted by mini-css-extract-plugin
module.exports = {"trading-chart":"style_trading-chart__bwHx_"};